import { RoutePaths } from '../enums';
import { gameLiveConnection } from '../services';
import { jackpotConnection } from '../services/JackpotConnection';

class LiveConnection {
  handleRouteChange(pathname) {
    return new Promise((res) => {
      if (pathname === RoutePaths.game) {
        gameLiveConnection.init().then(() => {
          res({ socketPath: pathname });
        });
      }
    });
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          gameLiveConnection.sendGameGetInitialState();
          res({ socketPath: window.location.pathname });
        });
      });
    });
  }

  restartJackpotConnection() {
    return new Promise((res) => {
      jackpotConnection.stop().then(() => {
        jackpotConnection.init().then(() => {
          jackpotConnection.sendGameGetInitialState();
          res({ socketPath: window.location.pathname });
        });
      });
    });
  }

  connectionInitCallback() {
    return gameLiveConnection.init().then(() => {
      gameLiveConnection.sendGameGetInitialState();
    });
  }

  jackpotConnectionInitCallback() {
    return jackpotConnection.init().then(() => jackpotConnection.sendGameGetInitialState());
  }
}

export const liveConnection = new LiveConnection();
